"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MemRepository {
    constructor() {
        this._store = new Map();
    }
    save(item) {
        this._store.set(item.id, item);
    }
    async saveAsync(item) {
        this.save(item);
    }
    update(item) {
        this._store.set(item.id, item);
    }
    async updateAsync(item) {
        this.update(item);
    }
    load(id) {
        if (!this._store.has(id))
            return null;
        return this._store.get(id) || null;
    }
    async loadAsync(id) {
        return this.load(id);
    }
    allKey() {
        return Array.from(this._store.keys());
    }
    allItem() {
        if (this._store.size === 0)
            return [];
        else
            return Array.from(this._store.values());
    }
    async allItemAsync() {
        return this.allItem();
    }
    contains(id) {
        return this._store.has(id);
    }
    delete(id) {
        if (this._store.has(id))
            this._store.delete(id);
    }
    async deleteAsync(id) {
        this.delete(id);
    }
    clear() {
        this._store.clear();
    }
    async clearAsync() {
        this.clear();
    }
}
exports.MemRepository = MemRepository;
//# sourceMappingURL=MemoryRepository.js.map